import { g as gsapWithCSS } from "@theme/theme";
class HeaderComponent extends window.HTMLElement {
  constructor() {
    super();
    this.DOM = {
      toggleBtn: this.querySelector(".js-toggle-menu"),
      toggleSubmenuBtns: this.querySelectorAll(".js-toggle-submenu")
    };
  }
  connectedCallback() {
    this.bindEvents();
  }
  bindEvents() {
    this.DOM.toggleBtn.addEventListener("click", () => this.toggleMegaMenu());
    this.DOM.toggleSubmenuBtns.forEach((btn) => {
      btn.addEventListener("click", this.toggleSubmenu.bind(this));
    });
    window.locomotiveScroll.lenisInstance.on("scroll", this.handleScroll.bind(this));
  }
  toggleMegaMenu() {
    this.DOM.toggleBtn.classList.toggle("is-active");
    this.classList.toggle("-show-mega-menu");
    if (this.classList.contains("-show-mega-menu")) {
      window.locomotiveScroll.stop();
    } else {
      window.locomotiveScroll.start();
    }
  }
  toggleSubmenu(e) {
    const currentBtn = e.currentTarget;
    const submenu = currentBtn.nextElementSibling;
    currentBtn.classList.toggle("is-active");
    gsapWithCSS.to(submenu, {
      height: currentBtn.classList.contains("is-active") ? "auto" : 0,
      duration: 0.75,
      ease: "easeInOutStrong"
    });
  }
  handleScroll() {
    const scrollTop = window.scrollY;
    if (scrollTop > 100) {
      this.classList.add("-scrolled");
    } else {
      this.classList.remove("-scrolled");
    }
  }
}
window.customElements.define("c-header", HeaderComponent);
